export enum VideoMode {
    AD,
    CONTENT,
    IDLE
}
